import { ReactComponent as NXlogo } from "@/assets/icons/nexus-logo.svg";
import RecapContent from "@/components/recap/RecapContent";
import useResponsive from "@/hooks/useResponsive.hook";
import { PrivateRoute } from "@nexus/shared-core";
import { Flex } from "antd";
import { useMemo } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router";

const RecapPage = () => {
  const { meetingId } = useParams();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const showHeader = useMemo(() => {
    const showHeaderParam = searchParams.get("showHeader");

    return showHeaderParam !== "false";
  }, [searchParams]);
  const isResponsive = useResponsive();

  return (
    <PrivateRoute>
      <Helmet>
        <title>{t("recap.helmet")}</title>
      </Helmet>
      <div
        className={isResponsive ? "recap-page" : "recap-page recap-background"}
      >
        {showHeader && (
          <Flex
            align="center"
            justify="flex-end"
            className="recap-page__header"
          >
            <NXlogo width={102} height={21} />
          </Flex>
        )}

        <Flex
          justify="center"
          align="flex-start"
          className="recap-page__content"
        >
          <RecapContent meetingId={meetingId || ""} />
        </Flex>
      </div>
    </PrivateRoute>
  );
};

export default RecapPage;
